import styled from "styled-components";

export const MonthsOptionsStyle = styled.div`
  display: flex;
  display: grid;
  grid-template-columns: repeat(auto-fit, 90px);
  justify-content: center;
  gap: 5px;
  width: 100%;
  max-width: 570px;
  margin: 0 auto;

  button {
    padding: 5px 16px;
  }
`;
